import { render, staticRenderFns } from "./AccountGroupsDialog.vue?vue&type=template&id=7dccb026"
import script from "./AccountGroupsDialog.vue?vue&type=script&lang=js"
export * from "./AccountGroupsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports